import { FilterQuery } from 'mongoose'; // must find proper solution
import { NormalizedReward, RewardData } from '../rewards/rewards';

export type KeysOfType<T> = keyof T;

export interface PaginationRequest<T = any, Populate extends string = string> {
  filters?: FilterQuery<T>;
  sort?: PaginationSort<T>;
  populate?: Populate[];
  returnTotal?: boolean;
  select?: string[];
  limit: number;
  page: number;
}

export interface PaginationResult<T = any> {
  total: number;
  results: T[];
}

export interface PaginationSort<T = any> {
  direction: SortDirection;
  field: keyof T | string;
}

export enum SortDirection {
  Asc = 1,
  Desc = -1,
}

export interface RewardResponse {
  success: boolean;
  data: { results: NormalizedReward[]; total: number };
  allData: RewardData;
}
